import { VideoCallTrackTypes } from '@protos/apps/video_call_track_types_pb'
import { VideoCallTroubleShootKeys } from '@protos/apps/video_call_trouble_shot_keys_pb'

export interface QuickMessageCategory {
  name: string
  badge: number
}

export interface QuickMessageItem {
  message: string
  category: string
  id: string | number
}

export type MediaPayloadType = 'audio' | 'video'

export enum DataMessageTypes {
  RefreshLocalTracks = 'RefreshLocalTracks',
  PresenceNotification = 'PresenceNotification',
  MediaNotification = 'MediaNotification',
  HangUp = 'HangUp',
  UnintentionalMute = 'UnintentionalMute',
}

interface DataMessageUniquePayload<T, P> {
  type: T
  payload: P
}

type DataMessageUnique =
  | DataMessageUniquePayload<
      DataMessageTypes.RefreshLocalTracks,
      {
        message: VideoCallTroubleShootKeys
        media: VideoCallTrackTypes
        recipientIdentity: string
      }
    >
  | DataMessageUniquePayload<
      DataMessageTypes.PresenceNotification,
      { message: string }
    >
  | DataMessageUniquePayload<
      DataMessageTypes.MediaNotification,
      { [k in MediaPayloadType]?: boolean }
    >
  | DataMessageUniquePayload<DataMessageTypes.HangUp, null>
  | DataMessageUniquePayload<
      DataMessageTypes.UnintentionalMute,
      { isMuted: boolean }
    >

type DataMessageIdentity = { identity?: string }

export type DataMessage = DataMessageIdentity & DataMessageUnique
